/**
 * @generated SignedSource<<a8a2ca54b8413463bae65b6ea2e9429f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CloudProvider = "AWS" | "Azure" | "GCP" | "Kubernetes" | "TencentCloud" | "%future added value";
export type ValidateAccountInput = {
  key: string;
  provider: CloudProvider;
};
export type ValidateAccountMutation$variables = {
  input: ValidateAccountInput;
};
export type ValidateAccountMutation$data = {
  readonly validateAccount: {
    readonly account: {
      readonly email: string | null | undefined;
      readonly id: string;
      readonly key: string;
      readonly name: string;
      readonly path: string | null | undefined;
      readonly provider: CloudProvider;
      readonly securityContext: string;
      readonly status: boolean | null | undefined;
      readonly status_message: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type ValidateAccountMutation = {
  response: ValidateAccountMutation$data;
  variables: ValidateAccountMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AccountPayload",
    "kind": "LinkedField",
    "name": "validateAccount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "path",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provider",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "securityContext",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status_message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ValidateAccountMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ValidateAccountMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cf01b9f2a7f58219e20e44e58b8336e0",
    "id": null,
    "metadata": {},
    "name": "ValidateAccountMutation",
    "operationKind": "mutation",
    "text": "mutation ValidateAccountMutation(\n  $input: ValidateAccountInput!\n) {\n  validateAccount(input: $input) {\n    account {\n      email\n      id\n      key\n      name\n      path\n      provider\n      securityContext\n      status\n      status_message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1bb8a11636c7e15d512cdeb3bde5c1d1";

export default node;
